module.exports = __webpack_public_path__ + "labioplastika_8_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/labioplastika_8_before.jpg
// module id = 1082
// module chunks = 0